"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollTop = void 0;
const react_1 = require("react");
const useScrollTop = (dependencies = []) => {
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
        // Disable eslint exhaustive-deps rule because is impossible to statically determine the dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
};
exports.useScrollTop = useScrollTop;
//# sourceMappingURL=index.js.map